import{styled as m}from"@mui/material/styles";import t from"@mui/material/Box";const e=m(t)((({theme:m})=>({border:`1px solid ${m.palette.black40.main}`})));export{e as Box};
//# sourceMappingURL=styles.js.map
